module.exports = require("/home/jenkins/workspace/Travelworld/Publish Production/.gatsby/gatsby-browser.tsx");